import styled, { FlattenSimpleInterpolation } from 'styled-components'
import { getProp } from '../utils/selector'

interface Props {
  gutter?: number
  alignment?: 'center' | 'stretch' | 'space-between'
  crossAlignment?: 'center' | 'flex-start' | 'stretch'
  innerStyle?: FlattenSimpleInterpolation
}

export const Container = styled.div<Props>`
  display: flex;
  justify-content: ${getProp('alignment', 'stretch')};
  align-items: ${getProp('crossAlignment', 'stretch')};

  ${getProp('innerStyle')}
`

export const Row = styled(Container)`
  flex-direction: row;

  ${({ gutter }: Props) =>
    gutter &&
    `
    > * + * {
      margin-left: ${gutter}px;
    }
  `}
`

export const Column = styled(Container)`
  flex-direction: column;

  ${({ gutter }: Props) =>
    gutter &&
    `
    > * + * {
      margin-top: ${gutter}px;
    }
  `}
`
